import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicRoutingModule } from './public-routing.module';

import { AuthTabComponent } from './auth-tab/auth-tab.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SharedModule } from '../dashboard-module/utils/shared.module';
import {ControlContainer, ReactiveFormsModule} from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { SmsVerificationComponent } from './sms-verification/sms-verification.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordResetVerificationComponent } from './password-reset-verification/password-reset-verification.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import {PublicMaterialModule} from './public-material.module';
import {MaterialModule} from '../material.module';

@NgModule({
    declarations: [
        AuthTabComponent,
        LoginComponent,
        SignupComponent,
        SmsVerificationComponent,
        PasswordResetComponent,
        PasswordResetVerificationComponent,
    ],
    imports: [
        PublicMaterialModule,
        ReactiveFormsModule,
        CommonModule,
        PublicRoutingModule,
        NgxMaskModule,
        SharedModule,
        SharedComponentsModule,
        MaterialModule,
    ],
    exports: [
        SmsVerificationComponent
    ]
})
export class PublicModule {}
